import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Logo } from '../Logo';
import { nav, site } from '../../data/site';
export function Footer() {
  return <footer className="border-t border-edge bg-carbon" data-id="element-667" data-mp="ale0u4tjpaui">
      <div className="mx-auto max-w-shell px-5 pb-12 pt-16 sm:px-6 lg:px-10 lg:pb-16" data-id="element-668" data-mp="ao06u00sfiam">
        <div className="flex flex-col gap-12 lg:flex-row lg:justify-between" data-id="element-669" data-mp="5msv5pvixyyo">
          <div className="max-w-sm" data-id="element-670" data-mp="ordn9dqy7pb">
            <Logo data-id="element-671" data-mp="pu2zcvf8234" />
            <p className="mt-6 text-sm leading-relaxed text-dim" data-id="element-672" data-mp="3s2x43c6tcx30">
              Passie, kwaliteit en service. Dat is wat ons onderscheidt van overige autowasstraten en
              poetsbedrijven.
            </p>
            <a href={site.instagram} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-1.5 text-sm text-ember transition-colors duration-200 ease-smooth hover:text-chalk" data-id="element-673" data-mp="3j2s0ze8nkkun">
              Instagram
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-674" data-mp="2kcl7rl7qp81z" />
            </a>
          </div>

          <div className="grid grid-cols-1 gap-10 sm:grid-cols-3 lg:gap-16" data-id="element-675" data-mp="2p4341vytikgm">
            <div data-id="element-676" data-mp="2bcol1p4wuj9k">
              <h2 className="text-xs uppercase tracking-[0.2em] text-dim" data-id="element-677" data-mp="2bd7t8e4rdtae">Menu</h2>
              <ul className="mt-5 space-y-3 text-sm" data-id="element-678" data-mp="2gb9lnpo2r4yj">
                {nav.map(item => <li key={item.to} data-id="element-679" data-mp="341df547jtobt">
                    <Link to={item.to} className="transition-colors duration-200 ease-smooth hover:text-ember" data-id="element-680" data-mp="342f2a71ua19w">
                      {item.label}
                    </Link>
                  </li>)}
                <li data-id="element-681" data-mp="2u2ed44hagqxs">
                  <Link to="/book" className="transition-colors duration-200 ease-smooth hover:text-ember" data-id="element-682" data-mp="2u50pqij1dwmv">
                    Online boeken
                  </Link>
                </li>
                <li data-id="element-683" data-mp="1img0xrqtdosc">
                  <Link to="/appointment" className="transition-colors duration-200 ease-smooth hover:text-ember" data-id="element-684" data-mp="1nmuaje82d6sh">
                    Mijn afspraak
                  </Link>
                </li>
              </ul>
            </div>

            <div data-id="element-685" data-mp="ziw1lta99q9i">
              <h2 className="text-xs uppercase tracking-[0.2em] text-dim" data-id="element-686" data-mp="zkfinm3qk5cc">Werkplaats</h2>
              <ul className="mt-5 space-y-3 text-sm text-dim" data-id="element-687" data-mp="ure0944blno0">
                <li className="text-chalk" data-id="element-688" data-mp="ptchkkat3qd2">{site.address}</li>
                {site.hours.map(h => <li key={h.day} data-id="element-689" data-mp="ktzxg7bbkxe6">
                    {h.day} · {h.time}
                  </li>)}
              </ul>
            </div>

            <div data-id="element-690" data-mp="ftlo8lxzfhek">
              <h2 className="text-xs uppercase tracking-[0.2em] text-dim" data-id="element-691" data-mp="fx9jbpj2sbve">Contact</h2>
              <ul className="mt-5 space-y-3 text-sm" data-id="element-692" data-mp="bttngvetyfjr">
                <li data-id="element-693" data-mp="6v062rwfa4eb">
                  <a href={site.phoneHref} className="transition-colors duration-200 ease-smooth hover:text-ember" data-id="element-694" data-mp="6vs4sblbgi8t">
                    {site.phone}
                  </a>
                </li>
                <li data-id="element-695" data-mp="219ja4ywm4fyg">
                  <a href={`mailto:${site.email}`} className="transition-colors duration-200 ease-smooth hover:text-ember" data-id="element-696" data-mp="21914jbo28pdv">
                    {site.email}
                  </a>
                </li>
                <li data-id="element-697" data-mp="2ihahl1m0k7ng">
                  <a href={site.whatsapp} target="_blank" rel="noreferrer" className="transition-colors duration-200 ease-smooth hover:text-ember" data-id="element-698" data-mp="2iivc4r8bvqlb">
                    WhatsApp
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-between gap-3 border-t border-edge pt-6 text-xs text-dim" data-id="element-699" data-mp="1zr2u1rusrpsd">
          <p data-id="element-700" data-mp="23tpdp5hbe4eh">
            © {new Date().getFullYear()} Daily Car Care, {site.city}. Gecertificeerd CARPRO CQuartz installateur.
          </p>
          <Link to="/admin" className="transition-colors duration-200 ease-smooth hover:text-ember" data-id="element-701" data-mp="3f82y20cv01pr">
            Beheeromgeving
          </Link>
        </div>
      </div>
    </footer>;
}